import styled from 'styled-components';

export const Wrapper = styled.div`
  .roles {
    display: flex;
    align-items: stretch;
    width: 100%;
    justify-content: stretch;
    height: 50px;
    overflow: auto;
    .role {
      white-space: nowrap;
      flex: 1;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      border-bottom: 1px solid var(--disabledColor);
      border-top: 1px solid transparent;
      font-size: 1.4rem;
      text-decoration: none;
      color: var(--fontColor);

      &.active,
      &:hover {
        border-bottom: 3px solid var(--mainColor);
        border-top: 3px solid transparent;
        font-weight: bold;
      }
    }
  }
  
  .tabs {
    padding: 10px 20px 0;
    height: 40px;
    display: flex;
    gap: 20px;
    align-items: stretch;
    overflow: auto;
    .tab {
      white-space: nowrap;
      display: flex;
      align-items: center;
      justify-content: center;
      cursor: pointer;
      font-size: 1.3rem;
      padding: 0 10px;
      text-align: center;
      text-decoration: none;
      color: var(--fontColor);
      &.active,
      &:hover {
        border-bottom: 3px solid var(--mainColor);
        border-top: 3px solid transparent;
      }
    }
  }
  .outlet {
    padding: 20px;
  }
`
